import { render } from "./ui-datetime-picker.vue?vue&type=template&id=79c873fd&scoped=true&ts=true"
import script from "./ui-datetime-picker.vue?vue&type=script&lang=ts"
export * from "./ui-datetime-picker.vue?vue&type=script&lang=ts"

import "./ui-datetime-picker.vue?vue&type=style&index=0&id=79c873fd&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c873fd"]])

export default __exports__